interface LoanSetting {
  min: {
    amount: number;
    term: number;
  };
  max: {
    amount: number;
    term: number;
  };
}

export const loanSettings: LoanSetting = {
  max: {
    amount: 50000,
    term: 84,
  },
  min: {
    amount: 1000,
    term: 12,
  },
};
